import { createAsyncThunkSelectors } from 'utils/createAsyncThunkSelectors'

export const {
  selectHasFulfilled: selectHasApproveLoanGroupFulfilled,
} = createAsyncThunkSelectors('loanGroup/approveLoanGroup')
